import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import whiteOnTextIcon from "../../assets/icons/whiteOnTextIcon.svg";
import greyOnTextIcon from "../../assets/icons/greyOnTextIcon.svg";
import offTextIcon from "../../assets/icons/offTextIcon.svg";

const CustomSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))({
  width: "96px",
  height: "34px",
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 0,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(48px)",
      color: "#1492AF",
      "& .MuiSwitch-thumb": {
        backgroundImage: `url("${whiteOnTextIcon}")`,
        color: "#1492AF",
        borderRadius: "0px 4px 4px 0px",
        backgroundRepeat: "no-repeat",
        width: "48px",
      },
      "& + .MuiSwitch-track": {
        backgroundColor: "#ffffff",
        opacity: 1,
        backgroundImage: `url("${offTextIcon}")`,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.3,
      },
      "&.Mui-disabled": {
        opacity: 0.5,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    height: "34px",
    color: "#E7E9EF",
    backgroundImage: `url("${offTextIcon}")`,
    borderRadius: "4px 0px 0px 4px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto",
    width: "48px",
    borderLeft: "1px solid #dbdee6",
    borderBottom: "1px solid #dbdee6",
    borderTop: "1px solid #dbdee6",
  },
  "& .MuiSwitch-track": {
    borderRadius: "4px",
    height: "32px",
    backgroundColor: "#ffffff",
    opacity: 1,
    border: "1px solid #dbdee6",
    backgroundImage: `url("${greyOnTextIcon}")`,
  },
});

export default CustomSwitch;
